import styled from 'styled-components';
import { Colors } from '../../../assets/styles/StyleTypes';

export const ArrowBack = styled.p`
  text-align: left;
  letter-spacing: 0px;
  color: ${props => props.theme.colors.textHeader};
  font-weight: normal;
  font-size: 12px;
  cursor: pointer;
  vertical-align: middle;
  display: flex;
  align-items: center;
  text-transform: uppercase;

  svg{
    font-size: 14px;
  }
`;

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.colors.background};
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: 600px) {
    padding: 0px;
    gap: 16px;
  }
`;

export const SectionCard = styled.section`
  width: 100%;
  max-width: 100%;

  @media (max-width: 768px) {
    padding: 20px;
  }

  @media (max-width: 600px) {
    padding: 0;
  }

  &.stats-expanded {
    padding: 0;
  }

`;

export const HeaderCard = styled(SectionCard)`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 600px) {
    padding: 20px;
  }
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const LocationInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const LocationNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const LocationName = styled.h1`
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${props => props.theme.colors.solidButton};

  @media (max-width: 600px) {
    font-size: 20px;
  }
`;

export const LocationCity = styled.span`
  font-size: 16px;
  color: ${props => props.theme.colors.textTitle};
  font-weight: 700;
`;

export const LocationAddress = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.colors.textPrimary};

  span {
    font-weight: 700;
    margin-right: 6px;

    &.cep {
      margin-left: 200px;
    }
  }

  strong {
    font-weight: 400;
  }

  @media (max-width: 600px) {
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: 6px;
    row-gap: 4px;
    line-height: 1.4;

    span {
      margin-right: 0;
    }

    span.cep {
      margin-left: 0;
    }
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: flex-start;
  
  button {
    min-width: 110px;
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

export const MobileHeaderActions = styled.div`
  display: none;

  @media (max-width: 600px) {
    display: flex;
    align-items: center;
    margin-left: auto;

    button {
      min-width: 110px;
      height: 36px;
      font-size: 13px;
    }
  }
`;

export const MetadataRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  border-top: 1px solid rgba(0, 73, 146, 0.12);
  padding-top: 10px;
`;

export const MetaItem = styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.colors.textPrimary};
  display: flex;
  gap: 6px;
  align-items: center;

  span {
    font-weight: 600;
    text-transform: uppercase;
    color: ${Colors.PRIMARY_PURE};
  }

  strong {
    font-weight: 500;
  }
`;

export const SectionTitleRow = styled.div`
  box-shadow: 0 0 0.7em ${props => props.theme.colors.boxShadow};
  border-radius: 10px;
  display:flex;
  justify-content: space-between;
  flex-direction: column;
  overflow: hidden;
  height: auto;
  max-width: 100%;

  &.equipment {
    height: 200px;
  } 
    
  &.stats {
    overflow-x: hidden;

    &.expanded {
      box-shadow: none;
      border-radius: 0;
    }
  }

  @media screen and (max-width: 960px) {
      border-radius: 0px;
      margin: 15px 0px 0px 0px;
  }

  @media (max-width: 768px) {
    &.equipment {
      height: 270px;
    }
  }
  
`;

export const SectionTitle = styled.h2`
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  padding: 0px 0px 0px 20px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  display: flex;
  color: #ffffff;
  background: transparent linear-gradient(90deg, #4F8FE9 0%, #5C51AF 100%) 0% 0% no-repeat padding-box;
  min-height: 40px;
  align-items: center;

  @media screen and (max-width: 960px) {
      border-radius: 0px;
  }
`;

export const StatsHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background: transparent linear-gradient(90deg, #4F8FE9 0%, #5C51AF 100%) 0% 0% no-repeat padding-box;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  @media (max-width: 960px) {
    border-radius: 0;
  }
`;

export const StatsHeaderTitle = styled(SectionTitle)`
  background: transparent;
  padding: 0;
  min-height: auto;
  color: #ffffff;

  @media (max-width: 960px) {
    border-radius: 0;
  }
`;

export const StatsContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 73, 146, 0.12);
  border-radius: 0 0 10px 10px;
  background: ${(props) => props.theme.colors.background};
  overflow: hidden;
  max-width: 100%;

  @media screen and (max-width: 960px) {
    border-radius: 0;
  }
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(260px, 0.95fr) 1px minmax(420px, 1.05fr);
  align-items: stretch;
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const StatsPanelBase = styled.div`
  border-radius: 14px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const UsagePanel = styled(StatsPanelBase)`
  align-items: center;
`;

export const VerticalDivider = styled.span`
  width: 2px;
  background: #025CB7;
  display: block;
  align-self: stretch;
  margin-top: 20px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const HorizontalDivider = styled.span`
  width: calc(100% - 40px);
  height: 2px;
  background: #025CB7;
  align-self: center;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

export const RecipePanel = styled(StatsPanelBase)`
  gap: 12px;
`;

export const PeakPanel = styled(StatsPanelBase)`
  min-height: 360px;
`;

export const PeakSection = styled(PeakPanel)`
  width: 100%;

  & .ppsa-empty-list-component-column {
      margin-top: 40px;
  }
`;

export const PanelTitle = styled.h3`
  font-size: 14px;
  color: ${props => props.theme.colors.textTitle};
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;

  &::after {
    content: '';
    flex: 1;
    height: 2px;
    background: #025CB7;
    border-radius: 2px;
  }

  &.recipe {
    padding-top: 12px;

    @media (max-width: 600px) {
      margin: 0px 0px 0px 20px;
    }

    &::after {
      content: '';
      flex: 1;
      height: 1px;
      background: ${props => props.theme.colors.textTitle};
      border-radius: 2px;
    }
  }
`;

export const DoughnutWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  .graphic {
    width: 100%;
    justify-content: center;
  }

  .graphic-content {
    max-width: 320px;
  }

  .doughnut {
    max-width: 260px !important;
    max-height: 260px !important;
  }

  .custom-legend {
    align-items: flex-start;
  }
`;

export const ChartWrapper = styled.div`
  width: 100%;
  min-height: 320px;
  display: flex;
  align-items: center;
  padding-bottom: 12px; 
  overflow-x: auto;
  @media (max-width: 960px) {
    overflow: auto;
  }
`;

export const EnergyWrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  width: 100%;
`;

export const EnergyCards = styled.div`
  display: grid;
  width: 100%;
  gap: 16px;
  grid-template-columns: repeat(4, minmax(180px, 1fr)) minmax(180px, 220px);
  grid-column: auto;
  justify-items: stretch;
  align-items: stretch;
  @media screen and (max-width: 1600px) {
    gap: 20px;
  }
  @media (max-width: 1150px) {
    grid-template-columns: repeat(3, minmax(180px, 1fr));
  }

  @media (max-width: 1090px) {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }

  @media (max-width: 700px) {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }
`;

export const EnergyCard = styled.div`
  background: ${(props) => props.theme.colors.backgroundGraphic} 0% 0% no-repeat padding-box;
  border-radius: 10px;
  padding: 10px;
  gap: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  width: 98%;
  max-height: 85px;
  @media screen and (max-width: 1600px) {
    width: 100%;
  }
  &.borderLeftBlue{
    border-left: 8px solid #4da6ff;
  }
  &.borderLeftGreen{
    border-left: 8px solid #33cc33;
  }
`;

export const EnergyCardLabel = styled.span`
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #6b7280;
  width: auto;
  white-space: nowrap;
  overflow: hidden;   
  text-overflow: ellipsis;
`;

export const EnergyCardValue = styled.span`
  font-size: 2rem;
  font-weight: 900;
  color: ${props => props.theme.colors.TooltipText};
`;

export const EnergyCardUnit = styled.span`
  font-size: 0.875rem;
  color: #4b5563;
  font-weight: 500;
`;

export const EnergyCardValueRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
`;

export const EnergyCompactStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  align-self: stretch;
  justify-content: flex-start;
`;

export const EnergyCompactCard = styled.div`
  background: ${(props) => props.theme.colors.backgroundGraphic} 0% 0% no-repeat padding-box;
  border-radius: 10px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  box-sizing: border-box;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  height: 50%;
`;

export const EnergyCompactValueRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

export const EnergyCompactValue = styled.span`
  font-size: 11px;
  font-weight: 800;
  color: ${props => props.theme.colors.TooltipText};
`;

export const EnergyCompactUnit = styled.span`
  font-size: 0.8rem;
  color: #4b5563;
  font-weight: 600;
`;

export const EnergyContent = styled.div`
  border-radius: 10px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  overflow-x: auto;
`;

export const EnergyChart = styled.div`
  width: 100%;
  min-height: 420px;
`;

export const EnergyToggle = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 4px 8px;

  label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    cursor: pointer;

    input {
      accent-color: #4F8FE9;
    }
  }
`;
